import { combineReducers } from "redux";
import { createSelector } from "reselect";
import {
  datosUsuarios,
  datosCambioContrasenia,
  datosSolicitarContrasenia,
  datosVerificarToken,
  countCarrito,
  dataLeeds,
  dataCompras,
  rUsuariosOkta,
  dataRenovaciones,
  dataGuardarFacturacionPymes
} from "./rlogin";
import datosRamos from "./rRamos";
import { datosSucursales, datosActualizarDisclaimer } from "./rRamos";
import {
  datosCotizacion, catalogosCotizacion, datosPago, datosAyuda, datosValidarPagoPendiente, datosObtenerUrlPlaceToPay, datosDashboard, deduciblesRolesDatos,
  datosFormasPago,
  datosDebitoAutomatico,
  datosListadoConductos,
  datosGuardarConducto,
  datosGuardarFormaPago,
  datosIdentificacionAP,
  catalogosHogar,
  dataFacturacion,
  dataParametros,
  dataGuardarFacturacion,
  dataPermisosCotizadores,
  dataTerritoriosComparador

} from './rCotizacion';
import dataProductoCarrito, { datosCarritoHogar, datosTotalesCabeceraCotizadores, datosDuplicidadPolizas, datosListaNegra, dataPlanesComparador } from './rCarritoProductos';
import datosPreguntasFrecuentes from "./rPreguntasFrecuentes";
import { datosProductosMenu, rServicios } from './rMenus';
import { datosContenido, dataIncentivos } from "./rContenidos";
import dataPymes from './rRamoPymes';
import rCotizacionResp from './rCotizacionResponsabilidad';
import {
  datosListarLimitesFinanciero, datosCotizacionFinanciero, dataFinanciero, datosCarritoFinanciero, datosListarCotizadores, datosEnviarPDFFinanciero, dataResponsabilidad,
  datosCotizacionResponsabilidad, datosCarritoResponsabilidad, datosProvinciasResponsabilidad, girosNegocioFinanciero
} from './rRamoLineaFinanciera'
import { datosCoberturasAP, datosCarritoAPTravelGroup, datosProductoCarritoAPTravelGroup, datosCalculosCotizacionAP, datosRecuperarCarritoAP, generarCotizacionPdfAP, datosEnviarCotizacionPdfAP, listaPlanesAccP, datosCarritoAccP, listaProvinciasAP, listaCiudadesAP, listaCoberturasAccP, datosRecuperarCarritoAccP, datosProcesoCarritoAccP, datosEnviarCotizacionPdfAccP } from './rRamosAccidentesPersonales';
import { rPlaceToPay } from './rPagos'
import { rFormularioVinculacion } from './rFormularioVinculacion'
import dataRecompraPaquete from "./rPolizas";
import dataBancosCuotas from "./rPolizas";
import { permisosReducer } from "./rPermisos";
import { dataBeneficiariosEndosos, dataEndosos } from "./rEndososBeneficiarios";





export default combineReducers({
  rFormularioVinculacion,
  rPlaceToPay,
  datosUsuarios,
  rUsuariosOkta,
  dataParametros,
  dataPymes,
  datosCambioContrasenia,
  datosSolicitarContrasenia,
  datosVerificarToken,
  datosRamos,
  datosSucursales,
  datosActualizarDisclaimer,
  datosCotizacion,
  rCotizacionResp,
  catalogosCotizacion,
  dataProductoCarrito,
  dataRecompraPaquete,
  dataBancosCuotas,
  countCarrito,
  datosPago,
  dataLeeds,
  dataCompras,
  datosAyuda,
  datosPreguntasFrecuentes,
  datosProductosMenu,
  rServicios,
  datosValidarPagoPendiente,
  datosObtenerUrlPlaceToPay,
  datosDashboard,
  datosContenido,
  dataIncentivos,
  deduciblesRolesDatos,
  dataRenovaciones,
  dataGuardarFacturacionPymes,
  datosFormasPago,
  datosDebitoAutomatico,
  datosListadoConductos,
  datosGuardarConducto,
  datosGuardarFormaPago,
  datosIdentificacionAP,
  datosListarCotizadores,
  datosListarLimitesFinanciero,
  girosNegocioFinanciero,
  dataFinanciero,
  datosCarritoFinanciero,
  datosCotizacionFinanciero,
  datosEnviarPDFFinanciero,
  dataResponsabilidad,
  datosProvinciasResponsabilidad,
  datosCotizacionResponsabilidad,
  datosCarritoResponsabilidad,
  catalogosHogar,
  datosCarritoHogar,
  datosCoberturasAP,
  datosCarritoAPTravelGroup,
  datosProductoCarritoAPTravelGroup,
  datosCalculosCotizacionAP,
  datosRecuperarCarritoAP,
  generarCotizacionPdfAP,
  datosEnviarCotizacionPdfAP,
  listaPlanesAccP,
  datosCarritoAccP,
  listaProvinciasAP,
  listaCiudadesAP,
  listaCoberturasAccP,
  dataFacturacion,
  dataGuardarFacturacion,
  datosRecuperarCarritoAccP,
  datosProcesoCarritoAccP,
  datosEnviarCotizacionPdfAccP,
  datosTotalesCabeceraCotizadores,
  datosDuplicidadPolizas,
  datosListaNegra,
  dataPlanesComparador,
  dataTerritoriosComparador,
  permisosReducer,
  dataEndosos,
  dataBeneficiariosEndosos
});

export const getValorBusqueda = createSelector(
  state => state.valorBusqueda,
  valorBusqueda => valorBusqueda
);

export const getNombreCategoria = createSelector(
  state => state.categoriaActiva,
  categoriaActiva => categoriaActiva
);
export const getDiccionarioBusquedas = state => state.diccionarioBusquedas;
export const getDataFromBusqueda = createSelector(
  state => state.diccionarioBusquedas,
  getValorBusqueda
);

export const getSubcategoriasActivas = createSelector(
  state => state.subCategorias,
  getNombreCategoria
);
